import {
  DueDiligenceAnswerType,
  DueDiligenceEvaluationMode,
  DueDiligenceStatusColor,
  StatusEvaluationConfig,
  ConditionGroup,
  DueDiligenceScope,
} from 'shared/types/due-diligence';

export interface AnswerOptionItem {
  id?: number;
  value: string;
  label: string;
  statusColor: DueDiligenceStatusColor;
  tooltipLabel?: string;
  isDefault: boolean;
  displayOrder: number;
  active: boolean;
  conditionRoot: ConditionGroup | null;
}

export interface QuestionItem {
  id?: number;
  fieldName: string;
  displayName: string;
  helpText?: string;
  displayOrder: number;
  active: boolean;
  answerOptions: AnswerOptionItem[];
  answerType: DueDiligenceAnswerType;
  /** @deprecated Use documentLabelIds instead */
  documentLabelId?: number;
  documentLabelIds: number[];
  aiExtractionHint?: string;
  evaluationMode: DueDiligenceEvaluationMode;
  statusEvaluationConfig?: StatusEvaluationConfig | null;
  /** @deprecated Use documentBehavior instead */
  aggregationConfig?: any | null;
  documentBehavior?: 'replacing' | 'cumulative';
  cumulativeConfig?: {
    approvalStatuses?: string[];
    trackAllDocuments?: boolean;
    enableSynthesis?: boolean;
  } | null;
  extractionValueType?: 'number' | 'string' | 'date' | 'boolean' | null;
  extractionPrompt?: string | null;
  extractionLabel?: string | null;
  dependencyConfig?: {
    sourceQuestionFieldName: string;
    useAs: 'comparison_value' | 'condition_input';
    comparison?: {
      databaseField: string;
      operator: '==' | '!=' | '>' | '<' | '>=' | '<=';
      resultMapping: {
        onMatch: string;
        onMismatch: string;
        onNoValue: string;
      };
    };
  } | null;
}

export interface CategoryFormData {
  name: string;
  description: string;
  icon: string;
  scope: DueDiligenceScope;
  displayOrder: number;
  active: boolean;
}

export const DEFAULT_FORM_DATA: CategoryFormData = {
  name: '',
  description: '',
  icon: '',
  scope: DueDiligenceScope.BUILDING,
  displayOrder: 0,
  active: true,
};

export function createEmptyQuestion(): QuestionItem {
  return {
    id: Date.now(),
    fieldName: '',
    displayName: '',
    helpText: '',
    displayOrder: 0,
    active: true,
    answerOptions: [],
    answerType: DueDiligenceAnswerType.OPTIONS,
    documentLabelIds: [],
    aiExtractionHint: '',
    evaluationMode: DueDiligenceEvaluationMode.MANUAL,
    statusEvaluationConfig: null,
    documentBehavior: 'replacing',
    cumulativeConfig: null,
    extractionValueType: null,
    extractionPrompt: null,
    extractionLabel: null,
    dependencyConfig: null,
  };
}

export function createEmptyAnswerOption(isFirst: boolean): AnswerOptionItem {
  return {
    value: '',
    label: '',
    statusColor: DueDiligenceStatusColor.GREEN,
    isDefault: isFirst,
    displayOrder: 0,
    active: true,
    conditionRoot: null,
  };
}

/** Status color options for dropdowns */
export const STATUS_COLOR_OPTIONS = [
  { value: DueDiligenceStatusColor.GREEN, label: 'Groen (In orde)', color: 'bg-green-500' },
  { value: DueDiligenceStatusColor.ORANGE, label: 'Oranje (Aandacht)', color: 'bg-orange-500' },
  { value: DueDiligenceStatusColor.RED, label: 'Rood (Actie vereist)', color: 'bg-red-500' },
  { value: DueDiligenceStatusColor.TRANSPARENT, label: 'Transparant (N.v.t.)', color: 'bg-transparent border border-gray-300' },
];

/** Scope options for dropdowns */
export const SCOPE_OPTIONS = [
  { value: DueDiligenceScope.BUILDING, label: 'Gebouw' },
  { value: DueDiligenceScope.UNIT, label: 'Unit' },
];
